import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { useSearchParams } from 'react-router';

/**
 * Consent Result Page
 *
 * This page displays the result of a consent operation.
 * It reads 'success' and 'error' query parameters from the URL.
 *
 * URL format: /tpp/consent/complete?success=true|false&error=ErrorMessage
 */
export const ConsentResultPage = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === 'true';
  const errorMessage = searchParams.get('error') || '';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <div className="flex flex-col items-center text-center">
          {success ? (
            <>
              <CheckCircleIcon className="mb-4 h-16 w-16 text-green-500" />
              <h1 className="mb-2 text-2xl font-bold text-gray-900">Consent Successful</h1>
              <p className="mb-6 text-gray-600">
                Your consent has been successfully processed. You can go back to the third party provider site.
              </p>
            </>
          ) : (
            <>
              <XCircleIcon className="mb-4 h-16 w-16 text-red-500" />
              <h1 className="mb-2 text-2xl font-bold text-gray-900">Consent Failed</h1>
              <p className="mb-6 text-gray-600">
                There was an issue processing your consent.
                {errorMessage && <span className="mt-2 block font-medium text-red-600">{errorMessage}</span>}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConsentResultPage;
